import axiosPost from "../axiosPost";

export const SBMDocumentoPdfIns = async (data, credentials) => {
    const {
        sbmDocumentoId,
        sbmDocumentoPDF,
        sbmDocumentoTicketsTag,
    } = data;
    const body = {
        service: "SBMDocumentoPDFIns",
        params: {
            sbmDocumentoId,
            sbmDocumentoPDF,
            sbmDocumentoTicketsTag,
            merchantId: 1
        },
    };

    const result = await axiosPost(body, credentials);
    return result;
};
